<template>
  <b-list-group>
    <b-list-group-item href="#">
      <p class="m-0" v-b-toggle="'av-accordion-1'">Tags</p>
      <b-collapse id="av-accordion-1" role="tabpanel" class="p-25">
        <ul class="list-unstyled p-1">
          <li v-for="tag in tagsOptions" :key="tag.id">
            <a
              href="#"
              @click.prevent="
                onClickDataType(SLOT_TYPES.TAG, {
                  id: `${tag.label}`,
                  label: `${tag.label} (${$t('live')})`,
                })
              "
            >
              - {{ tag.label }} ({{ $t("live") }})
            </a>
            <br />
            <a
              href="#"
              @click.prevent="
                onClickDataType(SLOT_TYPES.TAG, {
                  id: `${tag.label}:PA`,
                  label: `${tag.label} (${$t('pre_alarm')})`,
                })
              "
            >
              - {{ tag.label }} ({{ $t("pre_alarm") }})
            </a>
            <br />
            <a
              href="#"
              @click.prevent="
                onClickDataType(SLOT_TYPES.TAG, {
                  id: `${tag.label}`,
                  label: `${tag.label}`,
                })
              "
            >
              - {{ tag.label }}
            </a>
            <hr />
          </li>
        </ul>
      </b-collapse>
    </b-list-group-item>

    <b-list-group-item href="#" @click.prevent="onClickDataType(SLOT_TYPES.INFO, { source: 'alarm' })">
      {{ $t(`slot_types.${SLOT_TYPES.INFO}`) }}
    </b-list-group-item>

    <b-list-group-item href="#" @click.prevent="onClickDataType(SLOT_TYPES.MAP)">
      {{ $t(`slot_types.${SLOT_TYPES.MAP}`) }}
    </b-list-group-item>

    <b-list-group-item href="#" @click.prevent="onClickDataType(SLOT_TYPES.UNITS_MAP)">
      {{ $t(`slot_types.${SLOT_TYPES.UNITS_MAP}`) }}
    </b-list-group-item>

    <b-list-group-item href="#" @click.prevent="onClickDataType(SLOT_TYPES.GPS)">
      {{ $t(`slot_types.${SLOT_TYPES.GPS}`) }}
    </b-list-group-item>

    <b-list-group-item
      href="#"
      @click.prevent="onClickDataType(SLOT_TYPES.DETECTION_EVENT)"
    >
      {{ $t(`slot_types.${SLOT_TYPES.DETECTION_EVENT}`) }}
    </b-list-group-item>

    <b-list-group-item href="#" @click.prevent="onClickDataType(SLOT_TYPES.ACTION_PLAN)">
      {{ $t(`slot_types.${SLOT_TYPES.ACTION_PLAN}`) }}
    </b-list-group-item>

    <b-list-group-item href="#" @click.prevent="onClickDataType(SLOT_TYPES.PLANE)">
      {{ $t(`slot_types.${SLOT_TYPES.PLANE}`) }}
    </b-list-group-item>

    <!-- =================== Link options =================== -->
    <b-list-group-item href="#">
      <p class="m-0" v-b-toggle="'av-accordion-link'">Links</p>
      <b-collapse id="av-accordion-link" role="tabpanel" class="p-25">
        <ul class="list-unstyled p-1">
          <li v-for="link in linkOptions" :key="link.id">
            <a
              href="#"
              @click.prevent="
                onClickDataType(SLOT_TYPES.FRAME, {
                  id: link.id,
                  label: link.description,
                })
              "
            >
              - {{ link.description }}
            </a>
            <hr />
          </li>
        </ul>
      </b-collapse>
    </b-list-group-item>
    <b-list-group-item
      href="#"
      class="d-flex justify-content-between align-items-center"
      @click.prevent="onClickDataType(SLOT_TYPES.DRAGGABLE_MENU, { source: 'dmp_logs' })"
    >
      <p class="m-0" v-b-toggle="'av-accordion-dmp'">
        {{ $t(`dmp.title`) + " " + $t(`dmp.logs`) }}
      </p>

      <b-button
        size="sm"
        class="buttonFilter"
        v-b-popover.hover.html="filtersState.dmp_logs.filtersText || null"
        @click.stop.prevent="$bvModal.show('filter_modal')"
      >
        <b-icon-filter-circle-fill scale="1.1" />
        <span class="ml-1" v-if="filtersState.dmp_logs.filtersCount > 0">
          {{ filtersState.dmp_logs.filtersCount }}
        </span>
      </b-button>
      <DMPLogsFilters
        @filters-selected="onFiltersSelected('dmp_logs', $event)"
        @filters-applied="onFiltersApplied('dmp_logs', $event)"
        :filters="filtersState.dmp_logs.filters"
      />
    </b-list-group-item>
    <b-list-group-item
      href="#"
      class="d-flex justify-content-between align-items-center"
      @click.prevent="onClickDataType(SLOT_TYPES.DRAGGABLE_MENU, { source: 'hanwha_logs' })"
    >
      <p class="m-0" v-b-toggle="'av-accordion-hanwha-logs'">
        {{ $t(`hanwha_log.title`) }}
      </p>

      <b-button
        size="sm"
        class="buttonFilter"
        v-b-popover.hover.html="filtersState.hanwha_logs.filtersText || null"
        @click.stop.prevent="$bvModal.show('modal-hanwha-logs-filters')"
      >
        <b-icon-filter-circle-fill scale="1.1" />
        <span class="ml-1" v-if="filtersState.hanwha_logs.filtersCount > 0">
          {{ filtersState.hanwha_logs.filtersCount }}
        </span>
      </b-button>
      <HanwhaLogsFilters
        @filters-selected="onFiltersSelected('hanwha_logs', $event)"
        @filters-applied="onFiltersApplied('hanwha_logs', $event)"
        :filters="filtersState.hanwha_logs.filters"
      />
    </b-list-group-item>
    <b-list-group-item
      href="#"
      class="d-flex justify-content-between align-items-center"
      @click.prevent="
        onClickDataType(SLOT_TYPES.DRAGGABLE_MENU, { source: 'omnicloud_fr' })
      "
    >
      <p class="m-0" v-b-toggle="'av-accordion-omnicloud-fr'">
        {{ $t(`omnicloud_fr.face.title`) }}
      </p>

      <b-button
        size="sm"
        class="buttonFilter"
        v-b-popover.hover.html="filtersState.omnicloud_fr.filtersText || null"
        @click.stop.prevent="$bvModal.show('modal-omnicloud-fr')"
      >
        <b-icon-filter-circle-fill scale="1.1" />
        <span class="ml-1" v-if="filtersState.omnicloud_fr.filtersCount > 0">
          {{ filtersState.omnicloud_fr.filtersCount }}
        </span>
      </b-button>
      <OmnicloudFRFilters
        @filters-selected="onFiltersSelected('omnicloud_fr', $event)"
        @filters-applied="onFiltersApplied('omnicloud_fr', $event)"
        :filters="filtersState.omnicloud_fr.filters"
      />
    </b-list-group-item>
    <b-list-group-item
      href="#"
      class="d-flex justify-content-between align-items-center"
      @click.prevent="onClickDataType(SLOT_TYPES.DRAGGABLE_MENU, { source: 'alarm' })"
    >
      <p class="m-0" v-b-toggle="'av-accordion-dmp'">
        {{ $tc(`alarm.title`, 2) }}
      </p>
      <b-button
        size="sm"
        class="buttonFilter"
        v-b-popover.hover.html="filtersState.alarm.filtersText || null"
        @click.stop.prevent="$bvModal.show('modal-alarm-filters')"
      >
        <b-icon-filter-circle-fill scale="1.1" />
        <span class="ml-1" v-if="filtersState.alarm.filtersCount > 0">
          {{ filtersState.alarm.filtersCount }}
        </span>
      </b-button>
      <AlarmsFilters
        @filters-selected="onFiltersSelected('alarm', $event)"
        @filters-applied="onFiltersApplied('alarm', $event)"
        :filters="filtersState.alarm.filters"
      />
    </b-list-group-item>
    <b-list-group-item
      href="#"
      class="d-flex justify-content-between align-items-center"
      @click.prevent="onClickDataType(SLOT_TYPES.DRAGGABLE_MENU, { source: 'panel' })"
    >
      <p class="m-0" v-b-toggle="'av-accordion-dmp'">
        {{ $tc(`dmp.panel`, 1) }}
      </p>
    </b-list-group-item>
    <b-list-group-item
      href="#"
      class="d-flex justify-content-between align-items-center"
      @click.prevent="onClickDataType(SLOT_TYPES.INFO, { source: 'unit' })"
    >
      <p class="m-0" v-b-toggle="'av-accordion-dmp'">
        {{ $tc(`unit.title`, 1) }}
      </p>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import DMPLogsFilters from "@/views/dmp/components/SlotFiltersComponent.vue";
import OmnicloudFRFilters from "@/views/omnicloud_fr/Face/SlotFilters.vue";
import AlarmsFilters from "@/views/alarm/SlotFilters.vue";
import HanwhaLogsFilters from "@/views/hanwha/log/SlotFiltersComponent.vue";
import { BListGroup, BListGroupItem, BCollapse, VBToggle } from "bootstrap-vue";
import { SLOT_TYPES, SOURCES } from "@/config/layoutConfig";
import store from "@/store";

export default {
  components: {
    BListGroup,
    BListGroupItem,
    BCollapse,
    DMPLogsFilters,
    OmnicloudFRFilters,
    AlarmsFilters,
    HanwhaLogsFilters,
  },
  directives: {
    "b-toggle": VBToggle,
  },
  props: ["tagsOptions", "linkOptions", "filters"],
  data() {
    return {
      SLOT_TYPES,
      filtersState: {
        dmp_logs: {
          filters: {},
          filtersText: null,
          filtersCount: 0,
        },
        omnicloud_fr: {
          filters: {},
          filtersText: null,
          filtersCount: 0,
        },
        alarm: {
          filters: {},
          filtersText: null,
          filtersCount: 0,
        },
        panel: {
          filters: {},
          filtersText: null,
          filtersCount: 0,
        },
        hanwha_logs: {
          filters: {},
          filtersText: null,
          filtersCount: 0,
        },
      },
    };
  },
  methods: {
    setSlotData(type, name, data = {}) {
      store.dispatch("alarm_views/setSlotData", {
        type,
        name,
        data,
        source: SOURCES.ALARM_VIEW,
      });
    },
    onClickDataType(type, _data = {}) {
      let title = "";
      let data = {};

      switch (type) {
        case SLOT_TYPES.CAM_LIVE:
          title = this.$t(`slot_types.${SLOT_TYPES.CAM_LIVE}`);
          break;

        case SLOT_TYPES.CAM_PA:
          title = this.$t(`slot_types.${SLOT_TYPES.CAM_PA}`);
          break;

        case SLOT_TYPES.INFO:
          title = this.$t(`slot_types.${SLOT_TYPES.INFO}`);


          if (_data.source == "alarm") {
            data = {...data, source : 'alarm'};
          }


          if (_data.source == "unit") {
            title = this.$tc(`unit.title`, 1);
            data = {...data, source : 'unit'};
          }

          break;

        case SLOT_TYPES.MAP:
          title = this.$t(`slot_types.${SLOT_TYPES.MAP}`);
          break;

        case SLOT_TYPES.UNITS_MAP:
          title = this.$t(`slot_types.${SLOT_TYPES.UNITS_MAP}`);
          break;

        case SLOT_TYPES.PLANE:
          title = this.$t(`slot_types.${SLOT_TYPES.PLANE}`);
          break;

        case SLOT_TYPES.ACTION_PLAN:
          title = this.$t(`slot_types.${SLOT_TYPES.ACTION_PLAN}`);
          break;

        case SLOT_TYPES.TAG:
          title = `${this.$t(`slot_types.${SLOT_TYPES.TAG}`)}: ${_data.label}`;
          data = { tag: _data.id };
          break;

        case SLOT_TYPES.GPS:
          title = this.$t(`slot_types.${SLOT_TYPES.GPS}`);
          break;

        case SLOT_TYPES.DETECTION_EVENT:
          title = this.$t(`slot_types.${SLOT_TYPES.DETECTION_EVENT}`);
          break;

        case SLOT_TYPES.FRAME:
          title = `Link: ${_data.label}`;
          data = { link_id: _data.id };
          break;

        case SLOT_TYPES.DRAGGABLE_MENU:
          if (_data.source === "dmp_logs") {
            title = this.$t(`dmp.title`) + " " + this.$t(`dmp.logs`);
          }

          if (_data.source === "omnicloud_fr") {
            title = this.$t(`omnicloud_fr.face.title`);
          }

          if (_data.source === "alarm") {
            title = this.$tc(`alarm.title`, 2);
          }

          if (_data.source === "panel") {
            title = this.$t(`dmp.panel`);
          }

          if (_data.source === "hanwha_logs") {
            title = this.$t(`hanwha_log.title`);
          }

          // Snapshot: filtersState replaces this object on every Accept.
          data = {
            filters: { ...this.filtersState[_data.source].filters },
            source: _data.source,
          };
          break;
      }

      this.setSlotData(type, title, data);
    },
    onFiltersSelected(source, payload) {
      this.$set(this.filtersState, source, {
        ...this.filtersState[source],
        ...payload,
      });
    },
    onFiltersApplied(source, payload) {
      store.dispatch("alarm_views/applySlotFiltersBySource", {
        source,
        filters: payload.filters,
      });
    },
  },
  watch: {
    filters: {
      immediate: true,
      deep: true,
      handler(newFilters) {
        if (newFilters.filters && newFilters.filters.dmp_logs) {
          this.filtersState.dmp_logs.filters = { ...newFilters.filters.dmp_logs };
        }

        if (newFilters.filters && newFilters.filters.omnicloud_fr) {
          this.filtersState.omnicloud_fr.filters = { ...newFilters.filters.omnicloud_fr };
        }

        if (newFilters.filters && newFilters.filters.alarm) {
          this.filtersState.alarm.filters = { ...newFilters.filters.alarm };
        }

        if (newFilters.filters && newFilters.filters.panel) {
          this.filtersState.panel.filters = { ...newFilters.filters.panel };
        }

        if (newFilters.filters && newFilters.filters.hanwha_logs) {
          this.filtersState.hanwha_logs.filters = { ...newFilters.filters.hanwha_logs };
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.cameras-container {
  margin-top: 0.2rem;
  max-height: 300px;
  overflow: auto;
}
</style>
